import React from 'react';
import { Helmet } from 'react-helmet';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle, Phone } from 'lucide-react';
import { motion } from 'framer-motion';

const ExpiredQRPage = () => {
  return (
    <>
      <Helmet>
        <title>Session Expired - The Hotelier</title>
        <meta name="description" content="Your QR code session has expired. Please contact the front desk for assistance." />
      </Helmet>

      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          <Card className="border-destructive/50">
            <CardHeader className="text-center">
              <div className="mx-auto bg-destructive/10 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                <AlertCircle className="w-8 h-8 text-destructive" />
              </div>
              <CardTitle className="text-2xl">Session Expired</CardTitle>
              <CardDescription>
                Your QR code session has expired or is no longer valid
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground text-center leading-relaxed">
                This can happen if you have checked out or if the QR code was generated more than 7 days ago. 
                Please contact the front desk to get a new QR code.
              </p>

              <div className="bg-muted p-4 rounded-lg space-y-2">
                <p className="text-sm font-medium">Need help?</p>
                <p className="text-sm text-muted-foreground">
                  Visit the front desk or call reception for a new QR code
                </p>
              </div>

              <Button className="w-full transition-all duration-200" variant="outline">
                <Phone className="w-4 h-4 mr-2" />
                Contact Front Desk
              </Button>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </>
  );
};

export default ExpiredQRPage;